import { AccountingWorkpadsDraftsService_workPadsDraftsServiceGetGetDraftWorkPads } from '@festina/life-general-types/life/hooks/AccountingWorkpadsDraftsService_workPadsDraftsServiceGetGetDraftWorkPads'

export const useFetchDraftWorkPads =
  AccountingWorkpadsDraftsService_workPadsDraftsServiceGetGetDraftWorkPads.useSuspenseQuery
